import React, { useState, useCallback, useEffect } from "react";
import { ChoiceList } from "@shopify/polaris";
export const ChannelsModal = (props) => {
  const [selected, setSelected] = useState(props.selectedChannels);
  const handleChange = (value) => {
    setSelected(value);
    props.handleSelectedChannels(value);
  };

  return (
    <ChoiceList
      allowMultiple
      choices={props.channels}
      selected={selected}
      onChange={handleChange}
    />
  );
};
